// Types
import { Set } from '@globalTypes/store';
import { ReactElement } from 'react';
import { ModalStoreState } from './useModalStore.types';

/**
 * Returns an object containing actions related to the modal functionality.
 * @param set - The state setter function for the modal store state.
 * @returns An object with actions to perform modal operations.
 */
export const modalActions = (set: Set<ModalStoreState>) => ({
  /**
   * Opens the modal.
   */
  openModal: (modalBody: ReactElement) => set({ isModalOpen: true, modalBody }),
  /**
   * Closes the modal.
   */
  closeModal: () => set({ isModalOpen: false }),
});
